import type { EntityDetailSchema } from '../../types/schemas';
import { getConfigEntitySchemaWithDomainEntityAttributes } from '../get-config-entity-schema-with-domain-entity-attributes/get-config-entity-schema-with-domain-entity-attributes';

export const getConfigEntitySchemaWithDomainEntityAttributesAndRelationships = (
  configEntitySchema: EntityDetailSchema,
  domainEntitySchema: EntityDetailSchema,
) => {
  // Copy the domain entity's attributes schema into the config entity's schema
  const configSchemaWithDomainSchemaAttributes =
    getConfigEntitySchemaWithDomainEntityAttributes(
      configEntitySchema,
      domainEntitySchema,
    );

  // Also copy the domain entity's relationships if they exist
  const domainEntityRelationships = domainEntitySchema.properties.relationships;
  if (domainEntityRelationships) {
    configSchemaWithDomainSchemaAttributes.properties.relationships =
      domainEntityRelationships;
  }

  return configSchemaWithDomainSchemaAttributes;
};
